import { observer } from 'mobx-react-lite';

import { Avatar } from '@components/avatar';
import { IconButton } from '@components/icon-button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useAuthenticatedUser } from 'features/authentication';
import { useStore } from 'models/Provider';

export const NamePlate = observer((props) => {
  const { t } = useStore();
  const me = useAuthenticatedUser();
  const {
    name,
    title,
    picture,
    subTitle = null,
    actions = [],
    size = 'md',
    role = null,
    departments = null,
  } = props;
  const departmentTitles = (departments || [])
    .map((y) => y.translations.filter((z) => z.language === me.language).map((x) => x.title))
    .flat()
    .sort((a, b) => (a !== b ? (a < b ? -1 : 1) : 0));

  const roleAndDepartment = `${role ? t(`user.role.${role}`) : ''}${
    role && departmentTitles.length ? ' • ' : ''
  }${departmentTitles.join(', ')}`;

  return (
    <Stack space={3} orientation="horizontal" align="center" style={{ width: '100%' }}>
      <Avatar name={name} size={size} src={picture} />
      <div style={{ flexGrow: 1, minWidth: 0 }}>
        <Text ellipsis font="semibold14" color="purple100" text={name} />
        {title && <Text ellipsis font="regular14" color="purple80" text={title} />}
        {roleAndDepartment && (
          <Text
            ellipsis
            font="regular14"
            color="purple80"
            text={roleAndDepartment}
            tooltip={departmentTitles.join('\r\n')}
          />
        )}
        {subTitle && <Text ellipsis font="regular14" color="purple80" text={subTitle} />}
      </div>
      <Stack space={2} orientation="horizontal" justify="flex-end">
        {actions.map((action, index) => (
          <IconButton
            key={index}
            variant={action.trans ? 'ghost-purple' : 'secondary-purple'}
            icon={action.icon}
            onClick={action.onClick}
            tooltip={action.tooltipText}
          />
        ))}
      </Stack>
    </Stack>
  );
});
